// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"10":"6f9dd52feb5d2d1c","4112":"a3ede44e6a0beb25","7140":"a7423aeeee0005d7","7472":"b00d36148110c083","8787":"a1e3a7d3afb0d21c","9316":"9fec06d992112cf1"}[chunkId] + ".css";
};